import { render, staticRenderFns } from "./setGoodsValue.vue?vue&type=template&id=690b7d6c&scoped=true"
import script from "./setGoodsValue.vue?vue&type=script&lang=js"
export * from "./setGoodsValue.vue?vue&type=script&lang=js"
import style0 from "./setGoodsValue.vue?vue&type=style&index=0&id=690b7d6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b7d6c",
  null
  
)

export default component.exports